import * as React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';

import { getRoleList, saveRole } from 'Root/http';

import Roles from './Sidebar/Roles';
import Grants from './Grants';

import { routeGenerator, tabRoutes } from '../../../routes';
import { isSupervisorUser } from '../../../Auth/redux/auth.redux';

import s from './style/Roles.pcss';
import Loader from '../../../shared/components/Loader/Loader';


const initRole = { grantArray: [], isLocked: true };

@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class RolesTab extends React.Component {
  static propTypes = {
    isSupervisor: PropTypes.bool.isRequired,
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  state = {
    roles: [],
    roleGrants: [],
    isLocked: true,
    loading: false,
    saving: false,
  };

  componentDidMount() {
    this.setState({ loading: true }, () => {
      getRoleList()
        .then((roles) => {
          const { match } = this.props;
          let role = initRole;
          if (match.params.roleId) {
            role = roles.find(r => r.id === match.params.roleId) || initRole;
          }
          const nonLockedRoles = roles.filter(r =>
            !(this.props.isSupervisor && r.forbiddenForSupervisorAdmin));
          const isLocked = (role.isLocked || (this.props.isSupervisor && role.forbiddenForSupervisorAdmin));
          this.setState({
            roles: nonLockedRoles,
            roleGrants: role.grantArray || [],
            isLocked: isLocked || false,
            loading: false,
          });
        });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { match } = this.props;
    if (nextProps.match.params.roleId !== match.params.roleId && nextProps.match.params.roleId) {
      const role = this.state.roles
        .find(r => r.id === nextProps.match.params.roleId) || initRole;
      const isLocked = this.props.isSupervisor && role.forbiddenForSupervisorAdmin;
      this.setState({ roleGrants: role.grantArray || [], isLocked: isLocked || false });
    }
  }

  saveGrants = (grantArray) => {
    const body = {
      id: this.props.match.params.roleId,
      grantArray: grantArray.join(','),
      status: 'role_status_change',
    };
    return saveRole(body).then(() => {
      const roles = cloneDeep(this.state.roles);
      const changedRole = roles.find(role => role.id === this.props.match.params.roleId);
      changedRole.grantArray = grantArray;
      this.setState({ roles });
      return Promise.resolve();
    });
  };

  onCreateRole = body => new Promise((res) => {
    this.setState({ saving: true }, () => {
      saveRole(body).then((data) => {
        const roles = cloneDeep(this.state.roles);
        const newRoles = roles.concat({ id: data.id, name: data.name, grantArray: '' });
        this.setState({ roles: newRoles, saving: false }, () => {
          this.props.history.push(routeGenerator.roleEditLink(data.id));
        });
        res();
      });
    });
  });

  onEditRole = body => new Promise((res) => {
    this.setState({ saving: true }, () => {
      saveRole(body).then((data) => {
        const roles = cloneDeep(this.state.roles);
        const editedRole = roles.find(r => r.id === body.id);
        editedRole.name = data.name;
        this.setState({ roles, saving: false });
        res();
      });
    });
  });

  onRemoveRole = body => new Promise((res) => {
    this.setState({ saving: true }, () => {
      saveRole(body).then(() => {
        const roles = cloneDeep(this.state.roles);
        const newRoles = roles.filter(role => role.id !== body.id);
        this.setState({ roles: newRoles, saving: false }, () => {
          this.props.history.push(tabRoutes.roles);
        });
        res();
      });
    });
  });

  onRoleSelect = roleId =>
    this.props.history.push(routeGenerator.roleEditLink(roleId));

  render() {
    const selectedRoleId = this.props.match.params.roleId;
    if (this.state.loading) {
      return (
        <Loader />
      );
    }
    return (
      <div className={s.container}>
        <div className={s.rolesContainer}>
          <Roles
            selectedRole={selectedRoleId}
            roles={this.state.roles}
            saving={this.state.saving}
            onRoleSelect={this.onRoleSelect}
            onCreateRole={this.onCreateRole}
            onEditRole={this.onEditRole}
            onRemoveRole={this.onRemoveRole}
          />
        </div>
        {selectedRoleId &&
          <Grants
            onSave={this.saveGrants}
            roleGrants={this.state.roleGrants}
            isLocked={this.state.isLocked}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Roles/index.js